import { Zones } from '../correlation/components/Zones/Zones';

const ZonesTab = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        gap: '1.5rem'
      }}
    >
      <Zones />
    </div>
  );
};

export default ZonesTab;
